export const textAnimCon = {
  hidden: { x: -1000, opacity: 0 },
  show: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 1,
      delay: 0.5,
    },
  },
};

export const imgAnimitem = {
  hidden: { x: 1000, opacity: 0 },
  show: {
    x: 0,
    opacity: 1,
    transition: {
      duration: 1,
      delay: 0.5,
    },
  },
};

export const logoAnim = {
  hidden: { opacity: 0 },
  show: { opacity: 1 },
  transition: {
    duration: 0.5,
  },
};
